import { useState, useEffect } from 'react';
import { getSchools } from '../../services/scpApi';
import { defaultPageLimit } from '../../data/data';
import { current } from '@reduxjs/toolkit';
import CrudSchoolsListFilters from './CrudSchoolListFilters';
import Paginator from '../paginator/Paginator';
import dotsVertical from '../../assets/dots-vertical.svg';

const CrudSchoolList = ({ setSelectedSingleItemId, setView }) => {

    const [filters, setFilters] = useState({
        school: null
    });
    const [schools, setSchools] = useState([]);
    const [message, setMessage] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [pagination, setPagination] = useState({});

    // fetch schools
    useEffect(() => {
        (async () => {
            if (!schools || !currentPage) {
                setMessage('Please select a school');
                return;
            }

            try {
                // fetch schools data
                const data = await getSchools({
                    // schoolId: filters.school ? filters.school.id : null,
                    page: currentPage,
                    limit: defaultPageLimit,
                });

                // collect the relevant data from the response
                const fetchedSchools = data?.schools.map(school => ({
                    id: school.id,
                    name: school.name,
                    address: school.address,
                    website: school.website
                }));

                // set the students data
                setSchools(fetchedSchools);
                setMessage(fetchedSchools.length > 0 ? '' : 'No schools found');

                // set pagination data
                setPagination({
                    total: data?.total || 0,
                    currentPage: data?.current_page || 1,
                    perPage: data?.per_page || defaultPageLimit,
                    lastPage: data?.last_page || 1,
                });
            } catch (error) {
                console.error('Error fetching schools:', error);
                setMessage('Error fetching schools');
                setSchools([]);
            }
        })();

    }, [filters, currentPage]);

    const handleEditClick = (school) => {
        setSelectedSingleItemId(school.id);
        setView('single');
    };

    const clearFilters = () => {
        setFilters({
            school: null
        });
    }

    const columns = [
        { columnLabel: 'Name', dataKey: 'name' },
        { columnLabel: 'Address', dataKey: 'address' },
        { columnLabel: 'Website', dataKey: 'website' }
    ];

    return (
        <Paginator
            pagination={pagination}
            onPageChange={setCurrentPage}
        >
            <div className="">
                <div className="separator"></div>
                <div className='pagination-count'>Showing {schools.length} of {schools.length} school{schools.length !== 1 ? 's' : ''}</div>
                <div className='crud-list'>
                    <table className='custom-table'>
                        <thead>
                            <tr>
                                {columns.map(column => (
                                    <th key={column.columnLabel}>{column.columnLabel}</th>
                                ))}
                                <th>View / Edit</th>
                            </tr>
                            <tr className="separator-row"></tr>
                        </thead>

                        <tbody>
                            {message ? (
                                <tr>
                                    <td colSpan={columns.length + 1}>{message}</td>
                                </tr>
                            ) : (
                                schools.length > 0 ? (
                                    schools.map(school => (
                                        <tr key={school.id}>
                                            {columns.map(column => (
                                                <td key={column.dataKey}>{school[column.dataKey]}</td>
                                            ))}
                                            <td className='edit-dots'>
                                                <button
                                                    onClick={() => handleEditClick(school)}
                                                    className='edit-dots'>
                                                    <img src={dotsVertical} alt="Edit" />
                                                </button>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan={columns.length + 1}>No schools found</td>
                                    </tr>
                                )
                            )}
                        </tbody>
                    </table>
                </div>

            </div>
        </Paginator>
    );
};

export default CrudSchoolList;